
import { ArrowRight } from "lucide-react";
import { ContactButton } from "@/components/ui/button";
import { Container } from "@/components/ui/container";
import { cn } from "@/lib/utils";
import { toast } from "sonner";

interface CtaSectionProps {
  title: string;
  description?: string;
  ctaText: string;
  background?: "purple" | "light";
  className?: string;
  modalTitle?: string;
  modalDescription?: string;
  modalFormId?: string;
  additionalFields?: Record<string, string>;
}

export const CtaSection = ({
  title,
  description,
  ctaText,
  background = "purple",
  className,
  modalTitle = "Get Started",
  modalDescription = "Tell us about your security needs and challenges, and we'll help you find the right solution.",
  modalFormId = "dfa977cc-c726-4029-89d1-d8f757482a67",
  additionalFields = {
    lead_source: "Website",
    lead_interest: "Cybersecurity Services",
  }
}: CtaSectionProps) => {
  return (
    <section className={cn("py-16", className)}>
      <Container>
        <div 
          className={cn(
            "rounded-2xl p-8 md:p-12 text-center shadow-lg",
            background === "purple" 
              ? "bg-edgefi-purple" 
              : "bg-gray-50 border border-gray-200"
          )}
        >
          <h2 
            className={cn(
              "text-3xl font-bold mb-4",
              background === "purple" ? "text-white" : "text-gray-900"
            )}
          >
            {title}
          </h2>
          
          {description && (
            <p className={cn(
              "mb-8 max-w-2xl mx-auto",
              background === "purple" ? "text-purple-100" : "text-gray-600"
            )}>
              {description}
            </p>
          )}
          
          <ContactButton 
            variant={background === "purple" ? "default" : "cta"}
            size="lg"
            className={cn(
              "group",
              background === "purple" 
                ? "bg-white text-edgefi-purple hover:bg-purple-50" 
                : "bg-edgefi-purple text-white hover:bg-edgefi-purple/90"
            )}
            modalTitle={modalTitle}
            modalDescription={modalDescription}
            modalFormId={modalFormId}
            additionalFields={additionalFields}
            onFormSubmitted={() => {
              toast.success("Your message has been received. We'll be in touch soon!");
            }}
          >
            {ctaText}
            <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
          </ContactButton>
        </div>
      </Container>
    </section>
  );
}
